import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25 letter-spacing" }
const _hoisted_3 = { class: "row ms-0 me-0 align-items-center" }
const _hoisted_4 = { class: "col-lg-4 ps-0 pe-0 pb-25" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-lg-8 ps-0 pe-0" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "mt-8 pb-10 text-black fw-medium d-flex align-items-center" }
const _hoisted_9 = { class: "ms-10 pt-15 pt-md-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"mb-10 mb-md-25 d-flex justify-content-between\"><div class=\"title\"><h5 class=\"card-title fw-bold mb-7\">BP infos</h5><span class=\"d-block text-black fw-medium\">Pour vous, nous travaillons</span></div><div class=\"todays-event-swiper-pagination\"></div></div>", 1)),
      _createVNode(_component_swiper, {
        "slides-per-view": 1,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },
        pagination: {
          clickable: true,
        },
        modules: _ctx.modules,
        class: "todaysEventSwiper"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: course.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: course.image,
                        alt: "course-image"
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          to: "/event-details",
                          class: "fw-bold text-decoration-none text-black fs-3 ms-10"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(course.title), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("span", _hoisted_8, [
                          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "w-6 h-6 bg-white rounded-circle me-8" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(course.speakers), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_router_link, {
                            to: "",
                            class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("Lire la suite", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}